module.exports = __webpack_public_path__ + "static/img/question_banner.903d986.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/question_banner.png
// module id = BBCO
// module chunks = 3